import angular from 'angular';
import billfoldModule from './billfold/billfold';
import reportOrdersModule from './orders/orders';

let reportsModule = angular.module('app.reports', [
  billfoldModule.name,
  reportOrdersModule.name
]);

export default reportsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/reports.js
 **/